import { useEffect } from 'react';
import type { BrowserAgentComponent } from 'api/types';
import { getOrCreatePusher } from 'components/App/hooks/useInitPusher';
import { useAppDispatch } from 'hooks';
import { addWidgetComponents, setStreaming } from 'reducers/workflows';

interface BrowserAgentStepProps {
  setStepSent: (query?: string) => void;
  stepIndex: number;
  widgetComponent: BrowserAgentComponent;
}

interface BrowserAgentEventData {
  message: string;
}

export const BrowserAgentStep = ({
  setStepSent,
  widgetComponent,
}: BrowserAgentStepProps) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (widgetComponent.isSent) {
      return;
    }

    const channelId = widgetComponent.component_fields.channel_id;

    const pusher = getOrCreatePusher();

    dispatch(setStreaming(true));

    const channel = pusher.subscribe(channelId);

    channel.bind('browser-agent-success', (data: BrowserAgentEventData) => {
      const successMessage = data.message;

      dispatch(
        addWidgetComponents([
          {
            component_fields: {
              message: successMessage,
            },
            component_type: 'text_message',
            contextVariables: widgetComponent.contextVariables,
            isSent: true,
          },
        ]),
      );

      dispatch(setStreaming(false));
      setStepSent();
    });

    channel.bind('browser-agent-error', (data: BrowserAgentEventData) => {
      const errorMessage = data.message;

      dispatch(
        addWidgetComponents([
          {
            component_fields: {
              message: errorMessage,
            },
            component_type: 'text_message',
            contextVariables: widgetComponent.contextVariables,
            isSent: true,
          },
        ]),
      );

      dispatch(setStreaming(false));
      setStepSent();
    });

    return () => {
      channel.unbind_all();
      pusher.unsubscribe(channelId);
      dispatch(setStreaming(false));
    };
  }, [dispatch, setStepSent, widgetComponent]);

  return null;
};
